import React, { useEffect, useState } from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import ItemsListPDF from './ItemsListPDF'
import ItemsApp, { IItemModel } from './ItemsApp'
import { returnSingleItemDetailsFromList, useReturnAllItems } from './itemsSlice'
import { useReturnSingleDispplayer } from '../../components/DataDisplayer/dataDisplyerSlice'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { Checkbox, FormControlLabel, TextField } from '@mui/material'

interface IProps {
    goBack: () => void,
    selectedItems: IItemModel[],
}

export default function PrintSelectedItems(props: IProps) {

    const { goBack } = props

    const itemsApp = new ItemsApp()
    const displayerName: string = itemsApp.elemPrefix + "displayer"
    const dataDisplayer = useReturnSingleDispplayer(displayerName)

    const itemsList = useReturnAllItems()

    const displayerSelectedItems = dataDisplayer.selectedItems
    const [selectedItems, setSelectedItems] = useState<IItemModel[]>([])

    const [title, setTitle] = useState<string>("Export")
    const [details, setDetails] = useState<string>("")
    const [showSignatureBlock, setShowSignatureBlock] = useState<boolean>(false)
    const [groupByCategories, setGroupByCategories] = useState<boolean>(false)
    const [simplifyItems, setSimplifyItems] = useState<boolean>(false)

    /**
     * Selected items
     */
    // useEffect(() => {
        
    //     if (displayerSelectedItems.length > 0){

    //         let items: IItemModel[] = []

    //         displayerSelectedItems.map((item) => {
    //             if (itemsList.some(it => it.id === item)){
    //                 items.push(returnSingleItemDetailsFromList(item, itemsList))
    //             }
    //         })

    //         setSelectedItems(items)

    //     }else{
    //         setSelectedItems([])
    //     }

    // }, [displayerSelectedItems])

    useEffect(() => {
        if (props.selectedItems.length > 0){
            setSelectedItems(props.selectedItems)
        }
    }, [props.selectedItems])

    return(
        <div className="print-selected-items-main-page-container">

            <PageHeadSection pageName="items" customTitle="Print" customActionButtons={[
                {
                    icon: "print",
                    label: "Print",
                    onClick: () => window.print()
                }
            ]} hideBreadcrumbs triggerBack={goBack} />

            <div className="print-selected-items-form-container">
                <div style={{ height: 35 }}></div>
                <SectionBoxContainer>
                    <TextField variant="outlined" label="Title" fullWidth value={title} onChange={(e) => setTitle(e.target.value)} />
                    <TextField variant="outlined" multiline minRows={5} label="Details" fullWidth value={details} onChange={(e) => setDetails(e.target.value)} style={{ marginTop: 15 }} />
                    <FormControlLabel control={<Checkbox checked={showSignatureBlock} onChange={(e) => setShowSignatureBlock(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Show signature box" />
                    <FormControlLabel control={<Checkbox checked={groupByCategories} onChange={(e) => setGroupByCategories(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Group items by category" />
                    <FormControlLabel control={<Checkbox checked={simplifyItems} onChange={(e) => setSimplifyItems(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Simplify items" />
                </SectionBoxContainer>
            </div>

            <div className="print-selected-items-page-container">
                <ItemsListPDF items={selectedItems} title={title} details={details} showSignatureBlock={showSignatureBlock} groupByCategories={groupByCategories} simplifyItems={simplifyItems} />
            </div>

        </div>
    )
}